import React from "react";
import { useSelector } from "react-redux";
import { useLocation, Navigate } from "react-router-dom";
import { RootState } from "../../store";
import { ROUTE_CONFIG } from "../../utils/utils";
import { hasPermission } from "../../utils/permissionUtils";

interface PrivateRouteProps {
  page: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ page }) => {
  const { user, isAuthenticated, permissions } = useSelector(
    (state: RootState) => state.auth,
  );
  const location = useLocation();

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" />;
  }

  const route = ROUTE_CONFIG.find((r) => r.path === location.pathname);
  if (
    // If the user's role is superadmin, they have access to all routes
    user.role !== "SuperAdmin" &&
    route?.requiredPermission &&
    !hasPermission(permissions, route.requiredPermission)
  ) {
    return <Navigate to="/404" replace />;
  }

  return <>{page}</>;
};

export default PrivateRoute;
